import { render, staticRenderFns } from "./MessageWidgetMessages.vue?vue&type=template&id=0298d90c&"
import script from "./MessageWidgetMessages.vue?vue&type=script&lang=js&"
export * from "./MessageWidgetMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports